<template>
  <section class="preview">
    <form class="form" novalidate @submit.prevent="crear">
      <!-- Styled -->
      <mdb-input
        class="mb-3 mt-0"
        v-model="name"
        required
        invalidFeedback="Coloca el codigo"
      >
        <span class="input-group-text md-addon" slot="prepend">Nombre</span>
      </mdb-input>

      <div class="form-group">
        <label class="typo__label">Marketing provider</label>
        <multiselect
          v-model="provider"
          placeholder="Seleccione cuentas"
          label="name"
          track-by="value"
          :options="providers"
          :multiple="false"
          :taggable="true"
        ></multiselect>
      </div>

      <mdb-input
        placeholder="Version"
        class="mb-3 mt-0"
        v-model="api_version"
        required
        invalidFeedback="Coloca el codigo"
      >
        <span class="input-group-text md-addon" slot="prepend">Facebook API Version</span>
      </mdb-input>

      <mdb-input
        placeholder="user id"
        class="mb-3 mt-0"
        v-model="user_id"
        required
        invalidFeedback="Coloca el codigo"
      >
        <span class="input-group-text md-addon" slot="prepend">ID de usuario</span>
      </mdb-input>

      <mdb-input
        placeholder="app id"
        class="mb-3 mt-0"
        v-model="app_id"
        required
        invalidFeedback="Coloca el codigo"
      >
        <span class="input-group-text md-addon" slot="prepend">ID de App</span>
      </mdb-input>

      <mdb-input
        placeholder="business id"
        class="mb-3 mt-0"
        v-model="business_id"
        required
        invalidFeedback="Coloca el codigo"
      >
        <span class="input-group-text md-addon" slot="prepend">Business ID</span>
      </mdb-input>

      <mdb-input
        placeholder="user id"
        class="mb-3 mt-0"
        v-model="app_secret"
        required
        invalidFeedback="Coloca el codigo"
      >
        <span class="input-group-text md-addon" slot="prepend">Secret app</span>
      </mdb-input>

      <mdb-input
        placeholder="user id"
        class="mb-3 mt-0"
        v-model="access_token"
        required
        invalidFeedback="Coloca el codigo"
      >
        <span class="input-group-text md-addon" slot="prepend">Token</span>
      </mdb-input>

      <div class="text-center">
        <mdb-btn type="submit" color="primary" :disabled="isLoading">
          <span v-if="!isLoading">Crear</span>
          <semipolar-spinner :animation-duration="2000" :size="30" color="#ffffff" v-if="isLoading"></semipolar-spinner>
        </mdb-btn>
      </div>
    </form>
  </section>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mdbInput, mdbBtn } from "mdbvue";
import { SemipolarSpinner } from "epic-spinners";
import store from "../../store";
export default {
  name: "modal-1",
  components: {
    mdbInput,
    mdbBtn,
    SemipolarSpinner,
    Multiselect
  },
  props: {
    onClick: Function
  },
  data: () => {
    return {
      isLoading: false,
      name: "",
      api_version: "v5.0",
      user_id:"",
      app_id:"",
      business_id:"",
      app_secret:"",
      access_token:"",
      providers: [
          {name:"Facebook",value:"facebook"},
          {name:"Youtube",value:"youtube"}
      ],
      provider: {}
    };
  },
  async mounted() {
    //var respuesta = await this.getAccounts();
  },
  methods: {
    crear(event) {
      event.target.classList.add("was-validated");
      var { 
        name,
        api_version,
        user_id,
        app_id,
        business_id,
        app_secret,
        access_token,
        provider
       } = this;
      this.isLoading = true;
      if (name == "" || 
        provider == {} ||
        api_version == "" || 
        user_id == "" || 
        app_id == "" || 
        business_id == "" || 
        app_secret == "" || 
        access_token == "" 
        ) {
        this.isLoading = false;
      } else {
        var business = {
          name,
        api_version,
        user_id,
        app_id,
        business_id,
        app_secret,
        access_token,
        provider
        };
        store.dispatch("newBusiness", business).then(() => {
          /*this.name = "";
          this.website = "";
          this.email = "";
          this.street = "";
          this.phone = "";
          this.mobile = "";
          this.fax = "";
          this.selectedCountry = {};
          this.accountsSelected = [];
          this.pagesSelected = [];*/
          this.onClick();
          this.isLoading = false;
        });
      }
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.prueba-circulo {
  background-image: url("");
  background-repeat: no-repeat;
  width: 200px;
  height: 200px;
  background: #cccccc;
  border-radius: 100%;
  position: relative;
}
.form {
  position: relative;
  bottom: 80px;
}
</style>